import {
  reportLostConnectionError,
  reportSessionTimeout,
} from '../ui/report_error.js';
import { app } from './app.js';
import { DataRequestBase } from './data_request_base.js';
import { error } from './logger.js';

/**
 * HTTPs requester for the request server.
 */
class DataRequest extends DataRequestBase {
  ServiceUnavailable = 'SERVICE_UNAVAILABLE';
  SessionTimeout = 'SESSION_TIMEOUT';

  /**
   * Sends a data request.
   */
  async request(data, defaultValue) {
    let { response, status } = await super.request(data);
    switch (status) {
      case 0:
        if (!app.shutdown) {
          reportLostConnectionError();
        }
        return this.defaultValueOrError(defaultValue, this.ServiceUnavailable);

      case 401:
        reportSessionTimeout(() => app.logout('login?timeout'));
        return this.defaultValueOrError(defaultValue, this.SessionTimeout);

      default:
        return response;
    }
  }

  /**
   * Sends a generic request to the server.
   */
  async apiRequest(...args) {
    try {
      return await super.apiRequest(...args);
    } catch (e) {
      error(`[request] failed to send request`, e);
      return Promise.resolve();
    }
  }

  defaultValueOrError(defaultValue, errorCode) {
    return defaultValue !== undefined ? defaultValue : { errorCode };
  }
}

export default new DataRequest();
